import { useMutation, useQueryClient } from '@tanstack/react-query';
import _ from 'lodash';
import { toast } from 'react-toastify';

import { GoodLocation } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface SaveGoodLocationProps {
  goodLocation: GoodLocation;
  declarantId: string;
}

export const useSaveGoodLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ goodLocation, declarantId }: SaveGoodLocationProps) => {
      const isUpdate = goodLocation._id && goodLocation._id.length > 0;

      if (!isUpdate) {
        goodLocation = _.omit(goodLocation, ['_id']) as GoodLocation;
      }

      const result = isUpdate
        ? await apiClient.declarant.updateGoodLocation.mutation({
            params: { declarantId },
            body: { goodLocation },
          })
        : await apiClient.declarant.createGoodLocation.mutation({
            params: { declarantId },
            body: { goodLocation },
          });

      if (result.status !== 200) throw result.body;

      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['good-locations'] });
      toast.success('Good location saved successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error saving the good location!`);
    },
  });
};
